/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Scancontrol_Name1Inputs */

const en_resources_scancontrol_name1 = /** @type {(inputs: Resources_Scancontrol_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration of the order sheets`)
};

const fr_resources_scancontrol_name1 = /** @type {(inputs: Resources_Scancontrol_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration des bons de commandes`)
};

const es_resources_scancontrol_name1 = /** @type {(inputs: Resources_Scancontrol_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de órdenes de compra`)
};

const de_resources_scancontrol_name1 = /** @type {(inputs: Resources_Scancontrol_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan-Kontrolle`)
};

const nl_resources_scancontrol_name1 = /** @type {(inputs: Resources_Scancontrol_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integreren van de opdrachtbonnen`)
};

/**
* | output |
* | --- |
* | "Integration of the order sheets" |
*
* @param {Resources_Scancontrol_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_scancontrol_name1 = /** @type {((inputs?: Resources_Scancontrol_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Scancontrol_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_scancontrol_name1(inputs)
	if (locale === "fr") return fr_resources_scancontrol_name1(inputs)
	if (locale === "es") return es_resources_scancontrol_name1(inputs)
	if (locale === "de") return de_resources_scancontrol_name1(inputs)
	return nl_resources_scancontrol_name1(inputs)
});
export { resources_scancontrol_name1 as "resources.scanControl.name" }